import styled from 'styled-components';

import {
  Modal as SemanticModal,
  Radio as SemanticRadio,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Modal = styled(SemanticModal)`
    &.ui.modal {
    width: 530px;
  }
`;

const Container = styled.div`
  padding: 25px;
`;

const Title = styled(TextLayoutComponent.Title)``;

const Radio = styled(SemanticRadio)`
  margin-right: 5px;
`;

const ContainerRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 0 10px;
`;

const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 7px;
  align-items: center;
`;

const ContainerBottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 15px;
`;

const ButtonCancel = styled(ButtonLayoutComponent.Inverted)``;

const ButtonSave = styled(ButtonLayoutComponent)``;

export {
  Modal,
  Container,
  Title,
  Radio,
  ContainerRadioGroup,
  RadioContainer,
  ButtonCancel,
  ButtonSave,
  ContainerBottom,
};
